var React = require('react');

function Icons8XingSquared (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 5v22h22V5H5zm2 2h18v18H7V7zm12.639 2c-.22 0-.401.131-.551.381l-4.518 7.973 2.889 5.266c.141.25.321.381.561.381h2.039c.27 0 .39-.219.26-.439l-2.857-5.207v-.01l4.496-7.904a.28.28 0 0 0-.26-.439h-2.059zm-8.564 3c-.248 0-.387.198-.258.436l1.369 2.35-2.143 3.77c-.119.218.02.445.258.445h2.023c.208 0 .395-.128.545-.396l2.182-3.828-1.389-2.398c-.149-.248-.336-.377-.564-.377h-2.023z"}));
}

Icons8XingSquared.defaultProps = {"viewBox":"0 0 32 32","fill":"#000000","xmlnsV":"https://vecta.io/nano"};

module.exports = Icons8XingSquared;

Icons8XingSquared.default = Icons8XingSquared;
